import { render, staticRenderFns } from "./Components.ts.vue?vue&type=template&id=0c8c3a5a&"
import script from "./Components.ts.vue?vue&type=script&lang=ts&"
export * from "./Components.ts.vue?vue&type=script&lang=ts&"
import style0 from "./Components.ts.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports